import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
}) => {
  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;

    onPageChange(page);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-6 mt-7 border-t-2 pt-2">
      {/* INFO */}
      <div className="text-sm text-gray-500 font-medium ">
        Showing Page{" "}
        <span className="text-blue-600 font-bold">{currentPage}</span> of{" "}
        <span className="text-blue-600 font-bold">{totalPages}</span>{" "}
      </div>

      {/* PAGINATION */}
      <div className="flex items-center gap-2 flex-wrap">
        {/* PREVIOUS */}
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="w-11 h-11 rounded-full border border-gray-200 bg-white flex items-center justify-center hover:bg-blue-600 hover:text-white transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronLeft size={18} />
        </button>

        {/* PAGE NUMBERS */}
        {Array.from({ length: totalPages }, (_, index) => index + 1).map(
          (page) => (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={`w-11 h-11 rounded-full font-semibold transition-all duration-300 ${
                currentPage === page
                  ? "bg-blue-600 text-white shadow-lg scale-105"
                  : "bg-white border border-gray-200 text-gray-700 hover:bg-blue-600 hover:text-white"
              }`}
            >
              {page}
            </button>
          ),
        )}

        {/* NEXT */}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="w-11 h-11 rounded-full border border-gray-200 bg-white flex items-center justify-center hover:bg-blue-600 hover:text-white transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
